<footer class="sidebar-user-footer user-section d-flex flex-column align-items-stretch gap-2 border-top min-w-0 text-dark bg-transparent p-2">

  <PlatformSwitcher />

  <router-link
    v-if="is_admin"
    to="/user_management"
    class="sidebar-user-management-link d-flex align-items-center text-decoration-none w-100 border bg-white text-dark text-start rounded-2"
    aria-label="Open user management"
  >
    <i class="bi bi-people-fill sidebar-user-management-icon me-2 lh-1"></i>

    <span class="sidebar-user-management-text sidebar-menu-text fw-semibold text-xs">
      User Management
    </span>
  </router-link>

  <router-link
    to="/profile"
    class="sidebar-profile-link d-flex align-items-center text-decoration-none w-100 bg-body-tertiary text-dark py-1 px-0 min-w-0 rounded-2"
    aria-label="Open profile"
  >
    <div class="user-avatar rounded-circle me-2 d-flex justify-content-center align-items-center text-dark fw-semibold bg-warning lh-1">
      {{ initials }}
    </div>

    <div class="sidebar-user-name flex-grow-1 min-w-0">
      <p class="sidebar-user-name-text text-dark fw-bold text-xs mb-0 overflow-hidden">{{ full_name }}</p>
    </div>
  </router-link>

</footer>
